import { StatusPage } from '@data/components/composite/StatusPage/StatusPage';
import clifford404 from '@data/assets/clifford-404.png';

export function DataNotFoundPage() {
  return (
    <StatusPage
      heading="Page not found"
      description={
        <p>
          We&apos;re sorry, but we can&apos;t find that page.
          <br />
          Try checking the URL or going back to the homepage.
        </p>
      }
      illustration={clifford404}
      backLink={{ label: 'Back to Data and Insights', to: '/data' }}
      errorCode="404"
    />
  );
}
